/**
 * A Guardian link is a live surface, so a polling error must not erase the
 * last verified trip snapshot.  The snapshot is still useful (and safer than
 * claiming that a link was revoked) while the next bounded poll recovers.
 */
export type GuardianScreenState = 'loading' | 'ready' | 'invalid'

export function guardianScreenState(input: {
  isLoading: boolean
  hasSnapshot: boolean
}): GuardianScreenState {
  if (input.hasSnapshot) return 'ready'
  return input.isLoading ? 'loading' : 'invalid'
}
